module.exports = __webpack_public_path__ + "static/media/maca_igpost.0ab87eba.png";